<template lang="pug">
table-base.study-detail-table
  //- ヘッダー部
  table-row-base.study-detail-table__row-header.text-medium
    table-header-base.study-detail-table__row-header__cell.align-left
      toggle-sort.study-detail-table__row-header__cell__toggle(
        :sortSetting='sort.subject',
        @change-sort='sortChangeEvent($event, "subject")'
      )
        slot(name='subjectHeader')
    table-header-base.study-detail-table__row-header__cell.align-left
      toggle-sort.study-detail-table__row-header__cell__toggle(
        :sortSetting='sort.selection',
        @change-sort='sortChangeEvent($event, "selection")'
      )
        slot(name='selectionHeader')
    table-header-base.study-detail-table__row-header__cell.align-left
      toggle-sort.study-detail-table__row-header__cell__toggle(
        :sortSetting='sort.number',
        @change-sort='sortChangeEvent($event, "number")'
      )
        slot(name='numberHeader')
    table-header-base.study-detail-table__row-header__cell.align-left
      toggle-sort.study-detail-table__row-header__cell__toggle(
        :sortSetting='sort.endCondition',
        @change-sort='sortChangeEvent($event, "endCondition")'
      )
        slot(name='endConditionHeader')
    table-header-base.study-detail-table__row-header__cell.align-left
      .study-detail-table__row-header__cell__period
        .study-detail-table__row-header__cell__period__start
          toggle-sort.study-detail-table__row-header__cell__period__start__toggle(
            :sortSetting='sort.periodStartDate',
            @change-sort='sortChangeEvent($event, "periodStartDate")'
          )
            slot(name='periodStartDateHeader')
        .study-detail-table__row-header__cell__period__end
          toggle-sort.study-detail-table__row-header__cell__period__end__toggle(
            :sortSetting='sort.periodEndDate',
            @change-sort='sortChangeEvent($event, "periodEndDate")'
          )
            slot(name='periodEndDateHeader')
    table-header-base.study-detail-table__row-header__cell.align-center
      slot(name='registrationDateHeader')
  template(v-for='detail in studyDetails')
    //- 一覧表示部
    table-row-base.study-detail-table__row.text-small.font-medium
      table-data-base.study-detail-table__row__cell
        .study-detail-table__row__cell__text {{ detail.subject }}
      table-data-base.study-detail-table__row__cell
        .study-detail-table__row__cell__text {{ detail.selection }}
      table-data-base.study-detail-table__row__cell
        pulldown-select.study-detail-table__row__cell__pulldown(
          v-model='detail.numberValue',
          :selectOptions='numberSelectOptions',
          :disabled='detail.numberEditDisabled'
        )
      table-data-base.study-detail-table__row__cell
        pulldown-select.study-detail-table__row__cell__pulldown(
          v-model='detail.endConditionValue',
          :selectOptions='endConditionSelectOptions',
          :disabled='detail.endConditionEditDisabled'
        )
      table-data-base.study-detail-table__row__cell
        date-picker-range.study-detail-table__row__cell__date(
          :startEndDate='detail.period',
          @input='setPeriod($event, detail)',
          :disabled='detail.periodEditDisabled'
        )
      table-data-base.study-detail-table__row__cell.align-center
        .study-detail-table__row__cell__date-text {{ detail.registrationDate }}
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import TableBase from '@/components/atoms/TableBase.vue'
import TableRowBase from '@/components/atoms/TableRowBase.vue'
import TableHeaderBase from '@/components/atoms/TableHeaderBase.vue'
import TableDataBase from '@/components/atoms/TableDataBase.vue'
import ToggleSort from '@/components/molecules/manager/ToggleSort.vue'
import PulldownSelect from '@/components/molecules/manager/PulldownSelect.vue'
import DatePickerRange from '@/components/molecules/manager/DatePickerRange.vue'
import { InputItem } from '@/models/inputItem'
import { StudyDetailType, StudyDetailSortType } from '@/models/studyDetailModel'
import { StartEndDateType } from '@/models/datePickerModel'

/**
 * テスト詳細テーブル
 */
@Component({
  components: {
    TableBase,
    TableRowBase,
    TableHeaderBase,
    TableDataBase,
    ToggleSort,
    PulldownSelect,
    DatePickerRange,
  },
})
export default class StudyDetailTable extends Vue {
  // ソート値（項目毎の昇順フラグ）
  @Prop()
  sort!: StudyDetailSortType

  // ソート値変更時イベント
  @Prop()
  sortChangeEvent!: Function

  // テスト詳細表示情報
  @Prop()
  studyDetails!: StudyDetailType[]

  // 回数選択オプション
  @Prop()
  numberSelectOptions!: InputItem[]

  // 条件選択オプション
  @Prop()
  endConditionSelectOptions!: InputItem[]

  // 選択された期間を表示情報に設定
  private setPeriod(startEndDate: StartEndDateType, detail: StudyDetailType) {
    detail.period = startEndDate
  }
}
</script>

<style lang="stylus" scoped>
.study-detail-table
  width 100%

  &__row-header,
  &__row
    border-bottom 1px solid var(--color-manager-list__border)

  &__row-header
    background var(--color-manager-list__background)

    &__cell
      padding 10px

      &__period
        display flex
        gap 20px

        &__start
          width 180px

        &__end
          width 190px

  &__row
    background var(--color-manager-list__background)
    height 55px

    &__cell
      padding 0 10px

      &__pulldown
        width 110px
        min-width unset

      &__date-text
        opacity 0.4

    &:hover
      background var(--color-manager-list__hover)
</style>
